// extracted by mini-css-extract-plugin
export default {"accountDropdown":"SupportButton_accountDropdown__5nuHr","dropdown":"SupportButton_dropdown__osEen"};